module.exports = __webpack_public_path__ + "static/media/info-informationbutton.2e9b0a78.png";